<template>
  <tr>
    <td>
      <v-tooltip top>
        <template #activator="{on}">
          <v-btn icon v-on="on" :color="!model.comments || !model.comments.length ? 'grey' : 'primary' ">
            <v-icon>
              mdi-comment
            </v-icon>
          </v-btn>
        </template>
        <div v-if="!model.comments || !model.comments.length">No comment</div>
        <div v-for="comment in model.comments" :key="`comment_` + comment.id">
          {{ comment.user.username }} ({{ comment.timestamp }}) >
          <b>{{ comment.comment }}</b>
        </div>
      </v-tooltip>
      <BuiltValue v-if="model.built" :built="model.built" />
    </td>
    <td>{{ model.quantity }}</td>
    <td>{{ model.sst ? 'Yes' : 'No' }}</td>
    <td>{{ model.itemType }}</td>
    <td>
      <b>{{ model.headProduct.name }}</b><br>
      <span v-if="model.headSetting">Settings: {{ model.headSetting }}<br></span>
      <span v-if="model.headSetting2">Settings 2: {{ model.headSetting2 }}<br></span>
      <span v-if="model.headLoft">Loft: {{ model.headLoft }}<br></span>
      <span v-if="model.headLie">Lie: {{ model.headLie }}<br></span>
      <span v-if="model.headStamp">Stamping: {{ model.headStamp }}</span>
      <span v-if="model.headPaintfill">Paintfill: {{ model.headPaintfill }}<br></span>
    </td>
    <td>
      <template v-if="!model.headOnly">
        <b>{{ model.shaftProduct.name }}</b><br>
        <span v-if="model.shaftLength">Length: {{ model.shaftLength }}<br></span>
        <span v-if="model.shaftCpm">CPM: {{ model.shaftCpm }}<br></span>
        <span v-if="model.shaftSW">SW: {{ model.shaftSW }}<br></span>
        <span v-if="model.shaftPaintfill">Paintfill: {{ model.shaftPaintfill }}<br></span>
      </template>
    </td>
    <td>
      <template v-if="!model.headOnly">
        <b>{{ model.gripProduct.name }}</b><br>
        <span v-if="model.gripExtraWraps">Extra Wraps: {{ model.gripExtraWraps }}<br></span>
        <span v-if="model.gripLogo">Logo: {{ model.gripLogo }}</span>
      </template>
    </td>
    <td>
      <template v-if="model.statusBuild != 'built'">
        <v-tooltip v-if="!canBeBuilt" top>
          <template #activator="{on}">
            <v-icon color="red" v-on="on">
              mdi-alert
            </v-icon>
          </template>
          <div>
            This club can't be built - some components missing
          </div>
        </v-tooltip>
        <MarkClubAsBuilt v-if="canBeBuilt" :club="model" :handlingId="handling.id" @update="$emit('update')" />
      </template>
    </td>
  </tr>
</template>

<script>
import BuiltValue from '../prescriptions/built/BuiltValue.vue';
import MarkClubAsBuilt from './dialog/MarkClubAsBuilt.vue';

export default {
  components: {
    MarkClubAsBuilt,
    BuiltValue
},
  data: () =>  ({
    loading: false,
    comment: {
      form: false,
      text: null,
      action: null,
    },
    viewAllComment: false,
    mandatoryRules: [(v) => !!v || "This fiels is mandatory"],
  }),
  props: {
    item: {
      type: Object,
    },
    handling: {
      type: Object,
      required: true
    }
  },
  computed:{
    model:{
      get(){
        return this.item
      },
      set(model){
        this.$emit("update", model);
      }
    },
    canBeBuilt () {
      const headAvailable = this.handling.items.findIndex(hi => hi.quantity-hi.built>0 && hi.product_id == this.model.headProductId) >= 0
      const shaftAvailable = this.handling.items.findIndex(hi => hi.quantity-hi.built>0 && hi.product_id == this.model.shaftProductId) >= 0
      const gripAvailable = this.handling.items.findIndex(hi => hi.quantity-hi.built>0 && hi.product_id == this.model.gripProductId) >= 0
      
      if(this.model.headOnly){
        return headAvailable
      }else{
        return headAvailable && shaftAvailable && gripAvailable
      }
    }
  },
  methods: {
    openComment(type) {
      this.comment.form = true;
      this.comment.action = type;
    },
    markAsBuilt() {
      this.loading = true;
      this.$store
        .dispatch("build/markAsBuilt", {
          handlingId: this.handling.id,
          id: this.item.prescriptionRowId,
          model: this.model,
          comment: this.comment.text,
        })
        .then((result) => {
          if (result.success) {
            this.model.statusBuild = result.model.statusBuild;
            this.model.comments = result.model.comments;
            this.comment.text = "";
            this.comment.form = false;
            this.comment.action = null;
            this.$emit("update");
          } else {
            this.message = [];
            for (const field in result.message) {
              if ({}.propertyIsEnumerable.call(result.message, field)) {
                const msg = result.message[field];
                this.message.push(msg[0]);
              }
            }
          }
        })
        .finally(() => (this.loading = false));
    },
    markAsPending() {
      this.loading = true;
      this.$store
        .dispatch("build/markAsPending", {
          handlingId: this.handling.id,
          id: this.item.prescriptionRowId,
          model: this.model,
          comment: this.comment.text,
        })
        .then((result) => {
          if (result.success) {
            this.model.statusBuild = result.model.statusBuild;
            this.model.comments = result.model.comments;
            this.comment.text = "";
            this.comment.form = false;
            this.comment.action = null;
            this.$emit("update");
          } else {
            this.message = [];
            for (const field in result.message) {
              if ({}.propertyIsEnumerable.call(result.message, field)) {
                const msg = result.message[field];
                this.message.push(msg[0]);
              }
            }
          }
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>

<style></style>
